import { render, staticRenderFns } from "./WebinarRightMenu.vue?vue&type=template&id=5347167a&scoped=true"
import script from "./WebinarRightMenu.vue?vue&type=script&lang=js"
export * from "./WebinarRightMenu.vue?vue&type=script&lang=js"
import style0 from "./WebinarRightMenu.vue?vue&type=style&index=0&id=5347167a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5347167a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5347167a')) {
      api.createRecord('5347167a', component.options)
    } else {
      api.reload('5347167a', component.options)
    }
    module.hot.accept("./WebinarRightMenu.vue?vue&type=template&id=5347167a&scoped=true", function () {
      api.rerender('5347167a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Webinar/RightMenu/WebinarRightMenu.vue"
export default component.exports